var map = {
	"./AlertIcon.svg": "d9ed",
	"./AlertRoundIcon.svg": "3560",
	"./ApartmentApartment.svg": "6f90",
	"./ApartmentBusiness.svg": "55d9",
	"./ApartmentIcon.svg": "53d8",
	"./ApartmentLiving.svg": "f2f7",
	"./ApartmentParking.svg": "f996",
	"./ApartmentStore.svg": "0620",
	"./ArrowLeftIcon.svg": "b3bf",
	"./ArrowRightIcon.svg": "543f",
	"./AttachFileIcon.svg": "4f98",
	"./BoxIcon.svg": "3971",
	"./BrokenDeviceIcon.svg": "7edf",
	"./CalendarIcon.svg": "636e",
	"./CallIcon.svg": "c515",
	"./ChartsIcon.svg": "e5eb",
	"./CheckIcon.svg": "41ad",
	"./ChevronDown.svg": "5195",
	"./ClockIcon.svg": "d47f",
	"./CommentIcon.svg": "b778",
	"./CommercialIcon.svg": "c633",
	"./DownloadFile.svg": "a03b",
	"./ElectricityIcon.svg": "d5fb",
	"./ErrorIcon.svg": "a97b",
	"./ExchangeIcon.svg": "ab44",
	"./EyeIcon.svg": "33b0",
	"./EyeOffIcon.svg": "5b6d",
	"./FileGenerateIcon.svg": "f455",
	"./FileIcon.svg": "0ccf",
	"./FileViewIcon.svg": "f467",
	"./FilesIcon.svg": "13da",
	"./FilterIcon.svg": "74fa",
	"./FilterIcon2.svg": "4e9d",
	"./FolderIcon.svg": "86ff",
	"./GasIcon.svg": "bf7f",
	"./HashIcon.svg": "d673",
	"./HeaterIcon.svg": "ae80",
	"./HistoryIcon.svg": "394a",
	"./HomeIcon.svg": "b6a6",
	"./InfoBook.svg": "0497",
	"./InfoIcon.svg": "4946",
	"./InfoIcon2.svg": "2046",
	"./InvoiceIcon.svg": "4136",
	"./KeyEnterIcon.svg": "bc73",
	"./KeyIcon.svg": "b463",
	"./KeyTabIcon.svg": "fba4",
	"./LinkIcon.svg": "7e46",
	"./ListIcon.svg": "c2e2",
	"./LogoutIcon.svg": "40e1",
	"./MeterIcon1.svg": "e451",
	"./MoneyIcon.svg": "511a",
	"./NewFileIcon.svg": "887d",
	"./OneFileIcon.svg": "c48f",
	"./ParkingIcon.svg": "2d1b",
	"./PayIcon.svg": "ae59",
	"./PdfIcon.svg": "3ce8",
	"./PenIcon.svg": "15e8",
	"./PercentIcon.svg": "032c",
	"./PlusIcon.svg": "ebfa",
	"./PowerIcon.svg": "06ce",
	"./PowerOnIcon.svg": "aa10",
	"./ProfileIcon.svg": "3058",
	"./QuestionIcon.svg": "79bf",
	"./ReturnIcon.svg": "d0fe",
	"./RightArrowIcon.svg": "d54b",
	"./SaveIcon.svg": "5a57",
	"./SearchIcon.svg": "f5a1",
	"./SendIcon.svg": "8e9d",
	"./SettingsIcon.svg": "f1aa",
	"./SewerageIcon.svg": "f274",
	"./SupportIcon.svg": "8bc7",
	"./TasksIcon.svg": "4f45",
	"./TrashIcon.svg": "b7a9",
	"./TrelloIcon.svg": "dc95",
	"./UploadIcon.svg": "0409",
	"./UserIcon.svg": "33a3",
	"./WaterIcon.svg": "ce105",
	"./XIcon.svg": "0505"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";